import { IntlKey } from 'locales';
import { ListFieldMetadata } from 'models/forms/fields';
import { camelCaseToWords } from 'utils/string';

export function toListValue(
  value: unknown,
  fieldMetadata: ListFieldMetadata,
  translationMap: Partial<Record<IntlKey, string>>,
): string | undefined {
  if (typeof value !== 'string') {
    return undefined;
  }
  const matchedItem = fieldMetadata.availableItems.find(
    item => getTranslatedValue(item, fieldMetadata.id, translationMap) === value,
  );

  return matchedItem?.value ?? undefined;
}

function getTranslatedValue(
  item: { translationKey?: string; value: string; label: string },
  fieldId: string,
  translationMap: Partial<Record<IntlKey, string>>,
): string {
  const label = translationMap[`field.${item.label}` as IntlKey] ?? camelCaseToWords(item.label);
  const translationKey = `form.${fieldId}.${item.translationKey}` as IntlKey;
  const fallbackKey = `form.${fieldId}.${item.value}` as IntlKey;

  return translationMap[translationKey] ?? translationMap[fallbackKey] ?? label;
}
